const initialState = {
    resultsCouponsList: [],
    resultsCoupon: {}
  };
  
  const reducer = (state = initialState, action) => {
    const newState = { ...state };
    
    switch (action.type) {
      case "LIST_COUPON_RESPONSE_GET":
        newState.resultsCouponsList = action.value;
        break;
      case "COUPON_RESPONSE_GET":
        newState.resultsCoupon = action.value;
      default:
        break;
    }
    return newState;
  }
  
  export default reducer;
  


